import { __assign } from "tslib";
import React from 'react';
import classNames from 'classnames';
export var wrapChild = function (props) {
    var child = React.Children.only(props.children);
    return React.cloneElement(child, __assign(__assign(__assign({}, props), child.props), { className: classNames(props.className, child.props.className), style: __assign(__assign({}, child.props.style), props.style) }));
};
